import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, defineComponent } from 'vue'
const _hoisted_1 = {
  version: '1.1',
  xmlns: 'http://www.w3.org/2000/svg',
  'xmlns:xlink': 'http://www.w3.org/1999/xlink',
  x: '0px',
  y: '0px',
  viewBox: '0 0 512 512',
  'enable-background': 'new 0 0 512 512',
  'xml:space': 'preserve'
}
const _hoisted_2 = /*#__PURE__*/ _createElementVNode(
  'g',
  null,
  [
    /*#__PURE__*/ _createElementVNode('g', null, [
      /*#__PURE__*/ _createElementVNode('g', null, [
        /*#__PURE__*/ _createElementVNode('g', null, [
          /*#__PURE__*/ _createElementVNode('path', {
            d: 'M256,76c48.1,0,93.3,18.7,127.3,52.7S436,207.9,436,256s-18.7,93.3-52.7,127.3S304.1,436,256,436\n\t\t\t\t\tc-48.1,0-93.3-18.7-127.3-52.7C94.7,349.3,76,304.1,76,256s18.7-93.3,52.7-127.3C162.7,94.7,207.9,76,256,76 M256,48\n\t\t\t\t\tC141.1,48,48,141.1,48,256s93.1,208,208,208c114.9,0,208-93.1,208-208S370.9,48,256,48L256,48z'
          })
        ])
      ])
    ]),
    /*#__PURE__*/ _createElementVNode('g', null, [
      /*#__PURE__*/ _createElementVNode('path', {
        d: 'M256.7,160c37.5,0,63.3,20.8,63.3,50.7c0,19.8-9.6,33.5-28.1,44.4c-17.4,10.1-23.3,17.5-23.3,30.3v7.9h-34.7l-0.3-8.6\n\t\t\tc-1.7-20.6,5.5-33.4,23.6-44c16.9-10.1,24-16.5,24-28.9s-12-21.5-26.9-21.5c-15.1,0-26,9.8-26.8,24.6H192\n\t\t\tC192.7,182.7,216.5,160,256.7,160z M230.4,331.4c0-11.5,9.6-20.6,21.4-20.6c11.9,0,21.5,9,21.5,20.6s-9.6,20.6-21.5,20.6\n\t\t\tC239.9,352,230.4,343,230.4,331.4z'
      })
    ])
  ],
  -1
  /* HOISTED */
)
const _hoisted_3 = [_hoisted_2]
export default defineComponent({
  name: 'IosHelpCircleOutline',
  render: function render(_ctx, _cache) {
    return _openBlock(), _createElementBlock('svg', _hoisted_1, _hoisted_3)
  }
})
